export default __webpack_public_path__ + "sauces.7b95408c.svg";